module.exports = __webpack_public_path__ + "c687b64b96e59519a04b80a914139a44.png";